import axios from 'axios';

export const clinicalAnalyticsService = {
    getClientOverviewService: (clientId) => axios.get(`/clinical-analytics/client/${clientId}/overview`, { auth: true }),

    getDomainProgressService: (clientId, params) =>
        axios.get(`/clinical-analytics/client/${clientId}/domain-progress`, { auth: true, params: { ...params } }),

    getGoalsProgressService: (clientId, params) =>
        axios.get(`/clinical-analytics/client/${clientId}/goals-progress`, { auth: true, params: { ...params } }),

    getGoalDrilldownService: (clientId, goalId, params) =>
        axios.get(`/clinical-analytics/client/${clientId}/goal/${goalId}/drilldown`, { auth: true, params: { ...params } }),

    getGoalDrilldownSummaryService: (clientId, goalId, params) =>
        axios.get(`/clinical-analytics/client/${clientId}/goal/${goalId}/drilldown/summary`, { auth: true, params: { ...params } }),

    getGoalDrilldownTargetsService: (clientId, goalId, params) =>
        axios.get(`/clinical-analytics/client/${clientId}/goal/${goalId}/drilldown/targets`, { auth: true, params: { ...params } }),
};
